import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE, getImageUrl } from 'config/api';
import { BRAND_BLUE } from 'theme';

class ServiceCards extends Component {
    state = {
        services: [],
        loading: true
    };

    async componentDidMount() {
        try {
            const res = await fetch(`${API_BASE}/services`);
            const data = await res.json();
            this.setState({ services: Array.isArray(data) ? data : [], loading: false });
        } catch (e) {
            this.setState({ services: [], loading: false });
        }
    }

    render() {
        const { services, loading } = this.state;
        const { limit, showViewAll, showTitle = true } = this.props;
        const list = limit ? services.slice(0, limit) : services;

        if (loading) {
            return (
                <section className="modern-services-section">
                    <div className="container">
                        <p className="modern-services-status">Loading services…</p>
                    </div>
                </section>
            );
        }

        return (
            <section className="modern-services-section">
                {showTitle && (
                    <div className="modern-services-intro">
                        <div className="container">
                            <div className="modern-intro-panel">
                                <div className="title-section center modern-section-title modern-page-title">
                                    <h2>What We Offer</h2>
                                </div>
                                <p>Consulting and training in MERL and statistics.</p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="modern-services-stage">
                    <div className="container">
                        <div className="row modern-service-grid">
                            {list.map((data) => {
                                const imageUrl = getImageUrl(data.image);
                                const description = data.description
                                    ? (data.description.length > 120 ? data.description.slice(0, 120).trim() + '…' : data.description)
                                    : '';

                                return (
                                    <div className="col-lg-3 col-md-6 col-sm-12" key={data.id}>
                                        <article className="modern-service-card">
                                            <Link to={`/services/${data.slug}`} className="modern-service-card-link" title={data.title}>
                                                <div className={`modern-service-media${imageUrl ? '' : ' is-fallback'}`}>
                                                    {imageUrl ? (
                                                        <img
                                                            src={imageUrl}
                                                            alt={data.title}
                                                            onError={(e) => {
                                                                e.target.style.display = 'none';
                                                                e.target.parentElement.classList.add('is-fallback');
                                                            }}
                                                        />
                                                    ) : null}
                                                    <span
                                                        className="modern-service-icon"
                                                        style={{ color: data.iconColor || BRAND_BLUE, display: imageUrl ? 'none' : undefined }}
                                                    >
                                                        <i className={`fa ${data.icon || 'fa-bar-chart'}`} aria-hidden="true" />
                                                    </span>
                                                </div>
                                                <div className="modern-service-body">
                                                    <h3>{data.title}</h3>
                                                    {description && <p>{description}</p>}
                                                    <span className="modern-service-more">
                                                        Learn more <i className="fa fa-long-arrow-right" aria-hidden="true" />
                                                    </span>
                                                </div>
                                            </Link>
                                        </article>
                                    </div>
                                );
                            })}
                        </div>

                        {showViewAll && services.length > 0 && (
                            <div className="modern-services-view-all">
                                <Link to="/services-v1" className="modern-services-view-all-link">
                                    View all services
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}

export default ServiceCards;
